const translations = {
    agrianUnavailable:
        'Could not reach Agrian to re-derive the formulation. The verification is unchanged.',
    forbidden: 'Your account does not have permission to confirm formulations.',
    notFound: 'This product has not been enriched yet, so there is nothing to review.',
    rateLimited: 'Too many label reviews in the last minute. Wait a minute and try again.',
    unavailable: 'Formulation review is unavailable right now. Try again shortly.'
};

export default translations;
